import { faAddressBook, faBriefcase, faBuildingColumns, faCalendarCheck, faClock, faEnvelope, faFlag, faLandmarkDome, faLocationCrosshairs, faLocationDot, faMapLocationDot, faPenFancy, faPersonWalkingArrowRight, faPhone, faUser, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import { FaFacebook, FaInstagramSquare, FaLinkedin, FaTwitterSquare } from 'react-icons/fa'
import { formatDate, maskContactNumber } from '../../../../Utils/helpers/commonhelper'

export const ContactInfo = ({ contactDetails, checkTwilio, parsedUserEmail, parsedUserPhone, parsedTimezone, styles }) => {
    const [showAllEmails, setShowAllEmails] = useState(false);
    const [showAllPhoneNumbers, setShowAllPhoneNumbers] = useState(false);
    return (
        <Row className="w-100 ms-0 ps-0 pe-2 mb-2 contactDetailOffcanvas">
            <Col
                md={12}
                className="tab-container bg-white ps-0 pe-0"
                style={styles.tabContainer}
            >
                <Tab.Container defaultActiveKey="products">
                    <Nav
                        variant="pills"
                        className="nav-style-1 mb-0 d-flex flex-nowrap "
                    >
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="products"
                                style={styles.navLinksStyle}
                            >
                                Communication
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="cart"
                                style={styles.navLinksStyle}
                            >
                                Location
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="orders"
                                style={styles.navLinksStyle}
                            >
                                Social
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="offers"
                                style={styles.navLinksStyle}
                            >
                                Professional
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "22%" }}
                        >
                            <Nav.Link
                                eventKey="Campaign"
                                style={styles.navLinksStyleLast}
                            >
                                Internal
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            eventKey="Campaign"
                            className="me-0"
                            style={{
                                width: "-webkit-fill-available",
                            }}
                        >
                            {" "}
                            <Nav.Link
                                eventKey="Campaign"
                                style={styles.navLinksStyleLastLast}
                            ></Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane
                            eventKey="products"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-0 mt-3">
                                <Col
                                    md={6}
                                    className="mb-2 d-flex align-items-start "
                                >
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "1px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div className="w-100">
                                        <p className="mb-0" style={styles.labels}>
                                            Emails
                                        </p>

                                        <div
                                            style={{
                                                fontSize: "14px",
                                                color: "#333",
                                            }}
                                        >
                                            {parsedUserEmail?.[0] ? (
                                                <>
                                                    <span
                                                        style={{
                                                            display: "inline-block",
                                                            maxWidth: "290px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            verticalAlign: "middle",
                                                        }}
                                                        title={parsedUserEmail[0].email} // tooltip on hover
                                                    >
                                                        <span
                                                            className=" d-inline-block"
                                                            style={{
                                                                // display:"inline-block !important",
                                                                width: "70px",
                                                                minWidth: "60px",
                                                            }}
                                                        >
                                                            {parsedUserEmail[0].email_type}
                                                        </span>
                                                        {/* {parsedUserEmail?.[0].email_type ===
                                            "Office"
                                              ? "\u00A0\u00A0\u00A0\u00A0\u00A0"
                                              : " "} */}
                                                        : {parsedUserEmail[0].email}
                                                    </span>
                                                    <br />
                                                    {parsedUserEmail.length > 1 &&
                                                        !showAllEmails && (
                                                            <span
                                                                style={{
                                                                    color: "#0d6efd",
                                                                    cursor: "pointer",
                                                                    // marginLeft: "8px",
                                                                    fontSize: "13px",
                                                                }}
                                                                onClick={() =>
                                                                    setShowAllEmails(true)
                                                                }
                                                            >
                                                                +{parsedUserEmail.length - 1}{" "}
                                                                more
                                                            </span>
                                                        )}
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </div>

                                        {/* Expanded emails */}
                                        {showAllEmails && (
                                            <div
                                                style={{
                                                    marginTop: "6px",
                                                    fontSize: "14px",
                                                    color: "#333",
                                                    transition: "all 0.3s ease",
                                                }}
                                            >
                                                {parsedUserEmail
                                                    .slice(1)
                                                    .map((allEmails, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                marginBottom: "4px",
                                                                display: "inline-block",
                                                                maxWidth: "250px", // adjust as needed
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                verticalAlign: "middle",
                                                                // border:"1px solid black"
                                                            }}
                                                            title={allEmails.email} // tooltip
                                                        >
                                                            <span
                                                                className=" d-inline-block"
                                                                style={{
                                                                    // display:"inline-block !important",
                                                                    width: "70px",
                                                                    minWidth: "50px"
                                                                }}
                                                            >
                                                                {allEmails.email_type}
                                                                {/* {allEmails?.email_type ===
                                                "Office"
                                                  ? "\u00A0\u00A0\u00A0\u00A0\u00A0"
                                                  : " "} */}
                                                            </span>
                                                            : {allEmails.email}
                                                        </div>
                                                    ))}
                                                <br />
                                                <span
                                                    style={{
                                                        color: "#0d6efd",
                                                        cursor: "pointer",
                                                        fontSize: "13px",
                                                    }}
                                                    onClick={() =>
                                                        setShowAllEmails(false)
                                                    }
                                                >
                                                    Show less
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                                <Col
                                    md={6}
                                    className="mb-4 d-flex align-items-start"
                                    onClick={() => checkTwilio()}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "2px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div className="w-100">
                                        <p className="mb-0" style={styles.labels}>
                                            Contacts
                                        </p>

                                        <div
                                            style={{
                                                fontSize: "14px",
                                                color: "#333",
                                            }}
                                        >
                                            {parsedUserPhone?.[0] ? (
                                                <>
                                                    <span
                                                        style={{
                                                            display: "inline-block",
                                                            maxWidth: "280px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            verticalAlign: "middle",
                                                            letterSpacing: "0.25px"
                                                        }}
                                                        title={`${parsedUserPhone[0].phone_type} +${parsedUserPhone[0].country_code} ${maskContactNumber(parsedUserPhone[0].phone)}`} // full tooltip
                                                    >
                                                        <span
                                                            className=" d-inline-block"
                                                            style={{
                                                                // display:"inline-block !important",
                                                                width: "60px",
                                                                minWidth: "50px",
                                                                letterSpacing: '0.25px',
                                                            }}
                                                        >
                                                            {parsedUserPhone[0].phone_type}
                                                        </span>
                                                        : +{parsedUserPhone[0].country_code}{" "}
                                                        {maskContactNumber(parsedUserPhone[0].phone)}
                                                    </span>

                                                    <br />
                                                    {parsedUserPhone.length > 1 &&
                                                        !showAllPhoneNumbers && (
                                                            <span
                                                                style={{
                                                                    color: "#0d6efd",
                                                                    cursor: "pointer",
                                                                    fontSize: "13px",
                                                                }}
                                                                onClick={() =>
                                                                    setShowAllPhoneNumbers(true)
                                                                }
                                                            >
                                                                +{parsedUserPhone.length - 1}{" "}
                                                                more
                                                            </span>
                                                        )}
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </div>

                                        {/* Expanded contacts */}
                                        {showAllPhoneNumbers && (
                                            <div
                                                style={{
                                                    marginTop: "6px",
                                                    fontSize: "14px",
                                                    color: "#333",
                                                    transition: "all 0.3s ease",
                                                }}
                                            >
                                                {parsedUserPhone
                                                    .slice(1)
                                                    .map((allPhones, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                marginBottom: "4px",
                                                                display: "inline-block",
                                                                maxWidth: "250px",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                verticalAlign: "middle",
                                                            }}
                                                            title={`${allPhones.phone_type} +${allPhones.country_code} ${allPhones.phone}`} // tooltip
                                                        >
                                                            <span
                                                                className=" d-inline-block"
                                                                style={{
                                                                    // display:"inline-block !important",
                                                                    width: "60px",
                                                                    minWidth: "50px"
                                                                }}
                                                            >
                                                                {allPhones?.phone_type}
                                                            </span>
                                                            {/* {allPhones?.phone_type ===
                                                "Work"? "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" :
                                              allPhones?.phone_type === "Home"
                                                ? "\u00A0\u00A0\u00A0\u00A0\u00A0"
                                                : allPhones?.phone_type ===
                                                  "Mobile"
                                                ? "\u00A0\u00A0\u00A0\u00A0"
                                                : " "} */}
                                                            : +{allPhones.country_code}{" "}
                                                            {allPhones.phone}
                                                        </div>
                                                    ))}
                                                <br />
                                                <span
                                                    style={{
                                                        color: "#0d6efd",
                                                        cursor: "pointer",
                                                        fontSize: "13px",
                                                    }}
                                                    onClick={() =>
                                                        setShowAllPhoneNumbers(false)
                                                    }
                                                >
                                                    Show less
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-0 mt-0">
                                <Col
                                    md={6}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "2px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            TimeZone
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {parsedTimezone.label || "-"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="cart"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-4 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faFlag}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Country
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.country_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faBuildingColumns}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            State
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.state_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationCrosshairs}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            City
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.city_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Address
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.address || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faMapLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Zip Code
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.zipcode || "-"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="orders"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-3 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaFacebook
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Facebook
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.facebook || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaLinkedin
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Linkedin
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.linkedin || "-"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-4 mt-0">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaInstagramSquare
                                        className=" fs-16"
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Instagram
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.instagram || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaTwitterSquare
                                        className=" fs-16"
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Twitter
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.twitter || "-"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="offers"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-3 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLandmarkDome}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Company
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.company_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faBriefcase}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Department{" "}
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.department || "-"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-3 mt-0">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faAddressBook}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Designation{" "}
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.designation || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faPenFancy}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Decision Maker
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.decision_maker || "-"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="Campaign"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-4 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Created By
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.added_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Created At
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {formatDate(contactDetails?.created_at) ||
                                                "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faUser}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Modified By
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.updated_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faCalendarCheck}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Modified At
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.updated_at
                                                ? formatDate(contactDetails?.updated_at)
                                                : "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faUserCircle}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Lead Owner
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.owner_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-4 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faPersonWalkingArrowRight}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "4px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Lead Source
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {contactDetails?.lead_source_name || "-"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Col>
        </Row>
    )
}
